import React from "react";
import { useTranslation } from "react-i18next";

import { OnboardingSteps } from "../../utils/constants";
import WelcomePage from "../onboarding/WelcomePage/WelcomePage";
import ExploreGamesPage from "../onboarding/ExploreGamesPage/ExploreGamesPage";
import PaywallPage from "../onboarding/PaywallPage/PaywallPage";
import FindFriendsPage from "../onboarding/FindFriendsPage/FindFriendsPage";
import GetAppPage from "../onboarding/GetAppPage/GetAppPage";
import TurnOnNotificationsPage from "../onboarding/TurnOnNotificationsPage/TurnOnNotificationsPage";
import InsuranceBonusPage from "../onboarding/InsuranceBonusPage/InsuranceBonusPage";
import JoinCommunityPage from "../onboarding/JoinCommunityPage/JoinCommunityPage";
import InstallTestflightPage from "../onboarding/InstallTestflightPage/InstallTestflightPage";
import useOnboardingSteps from "../../hooks/useOnboardingSteps";
import {
  extractOgTitleFromMainTitle,
  renderHeaders,
} from "../../utils/renderHeaders";

function SignUpWelcomeFlowPage() {
  const { currentStep } = useOnboardingSteps();
  const { t } = useTranslation();

  let contentEl: JSX.Element;

  switch (currentStep) {
    case OnboardingSteps.VIEW_WELCOME:
      contentEl = <WelcomePage />;
      break;
    case OnboardingSteps.PAYWALL:
      contentEl = <PaywallPage />;
      break;
    case OnboardingSteps.EXPLORE_GAMES:
      contentEl = <ExploreGamesPage />;
      break;
    case OnboardingSteps.FIND_FRIENDS:
      contentEl = <FindFriendsPage />;
      break;
    case OnboardingSteps.JOIN_COMMUNITY:
      contentEl = <JoinCommunityPage />;
      break;
    case OnboardingSteps.GET_APP:
      contentEl = <GetAppPage />;
      break;
    case OnboardingSteps.INSTALL_TEST_FLIGHT:
      contentEl = <InstallTestflightPage />;
      break;
    case OnboardingSteps.TURN_ON_NOTIFICATIONS:
      contentEl = <TurnOnNotificationsPage />;
      break;
    case OnboardingSteps.VIEW_INSURANCE_BONUS:
      contentEl = <InsuranceBonusPage />;
      break;
    default:
      contentEl = <WelcomePage />;
  }

  return (
    <>
       {renderHeaders({
        title: t("metadata:sigma_onboarding_title"),
        description: t("metadata:sigma_onboarding_description"),
        ogTitle: extractOgTitleFromMainTitle(
          t("metadata:sigma_onboarding_title")
        ),
      })}
      {contentEl}
    </>
  );
}

export default SignUpWelcomeFlowPage;
